import { defineMessages } from 'react-intl';

import ButtonEdit from './ButtonEdit';
import { ButtonSchemaEnhancer } from './ButtonSchemaEnhancer';
import ButtonView from './ButtonView';
import { buttonSchema } from './schema';

import iconSVG from './icons/button.svg';

defineMessages({
  button: {
    id: 'Button',
    defaultMessage: 'Button',
  },
});

const applyConfig = (config) => {
  config.blocks.blocksConfig.buttonBlock = {
    id: 'buttonBlock',
    title: 'Button',
    group: 'text',
    icon: iconSVG,
    view: ButtonView,
    edit: ButtonEdit,
    blockSchema: buttonSchema,
    schemaEnhancer: ButtonSchemaEnhancer,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };
  return config;
};

export default applyConfig;
